import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const PlatformContext = createContext(null);

const DEFAULTS = {
  title: "GEMS",
  tagline: "Split expenses. Settle up. Stay friends.",
  description: "GEMS is a modern group-expense management platform with an immutable ledger for small crews.",
  logo_url: "",
  favicon_url: "",
  meta_description: "",
  meta_keywords: "",
};

export function PlatformProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = async () => {
    try {
      const { data } = await api.get("/public/platform-settings");
      setSettings({ ...DEFAULTS, ...data });
      if (data.title) document.title = data.title;
      const walletFavicon = "/favicon.svg";
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = data.favicon_url || walletFavicon;
      if (data.meta_description) {
        let m = document.querySelector('meta[name="description"]');
        if (!m) {
          m = document.createElement("meta");
          m.name = "description";
          document.head.appendChild(m);
        }
        m.content = data.meta_description;
      }
    } catch (_) {}
  };

  useEffect(() => { refresh(); }, []);

  return <PlatformContext.Provider value={{ settings, refresh }}>{children}</PlatformContext.Provider>;
}

export function usePlatform() {
  return useContext(PlatformContext) || { settings: DEFAULTS, refresh: () => {} };
}
